import React from 'react';
import { withRouter } from 'react-router-dom';
import Grid from './Grid.jsx';

class EstoqueCentro extends React.Component {

    constructor() {

        super();

        this.state = {
            gridHeader: [
                "Produto",
                "Embalagem",
                "Unidade",
                "Qtdd. Embalagem",
                "Unidades Disponíveis",
                "Status" ],
            estoque: [],
            centroId: 0,
            centro: "",
            status: "Ativo"
        };

        this.changeStatus = this.changeStatus.bind(this);
        this.voltar = this.voltar.bind(this);
        this.cadastrar = this.cadastrar.bind(this);
        this.fluxo = this.fluxo.bind(this);

    }

    changeStatus(e) {

        this.setState({ status: e.target.value });
        let status = e.target.value;

        fetch("/api/estoque/grid/" + this.state.centroId + "/" + status, {
            method: "GET",
            headers: {
                "Content-type": "application/json",
                "Authorization": "Basic " + btoa(localStorage.auth)
            },
            mode: "cors"
        })
        .then(response => response.json())
        .then(responseJson => {

            this.setState({ estoque: [] });
            this.setState({ estoque: responseJson });

        });

    }

    voltar() {
        this.props.history.push("/estoque");
    }

    cadastrar() {

        let obj = {
            centroId: this.state.centroId,
            centro: this.state.centro
        };

        this.props.history.push({
            pathname: "/cadastrarproduto",
            state: obj
        });

    }

    fluxo() {

        let obj = {
            centroId: this.state.centroId,
            centro: this.state.centro
        };

        this.props.history.push({
            pathname: "/fluxoestoque",
            state: obj
        });

    }

    componentDidMount() {

        if (localStorage.roleEstoque === "nenhuma") {
            window.location.href = "/home";
        }

        if (this.props.location.state === undefined) {
            window.location.href = "/estoque";
        }

        let cId = this.props.location.state.row.id;
        let centroNome = this.props.location.state.row.data[0];
        this.setState({ centroId: cId });
        this.setState({ centro: centroNome });

        fetch("/api/estoque/grid/" + cId + "/Ativo", {
            method: "GET",
            headers: {
                "Content-type": "application/json",
                "Authorization": "Basic " + btoa(localStorage.auth)
            },
            mode: "cors"
        })
        .then(response => response.json())
        .then(responseJson => {

            this.setState({ estoque: responseJson });

        });

    }

    render() {
        return(
            <div>
                <h1 id="estoque-centro-title">Estoque</h1><br />
                <p id="estoque-centro-txt">
                    Escolha um produto para verificar suas informações.
                </p><br /><br />
                <p id="estoque-centro-centro">
                    <b>Centro: </b> { this.state.centro }
                </p><br />
                <form id="estoque-centro-filtro">
                    <span>Filtrar por status: </span>
                    <select value={ this.state.status } onChange={ this.changeStatus }>
                        <option value="Ativo">Ativo</option>
                        <option value="Inativo">Inativo</option>
                        <option value="Todos">Todos</option>
                    </select>
                </form>
                <br /><br />
                <Grid key={ this.state.estoque }
                    header={ this.state.gridHeader }
                    data={ this.state.estoque }
                    pageSize={ 10 }
                    gridWidth={ "600px" }
                    linkTo={ "/visualizarproduto" } />
                <br />
                <button id="estoque-centro-voltar-btn" onClick={ this.voltar }>
                    Voltar
                </button>
                { localStorage.roleEstoque === "escrever" &&
                    <button id="estoque-centro-cadastrar-btn" onClick={ this.cadastrar }>
                        Cadastrar Produto
                    </button> }
                <button id="estoque-centro-fluxo-btn" onClick={ this.fluxo }>
                    Fluxo de Estoque
                </button>
            </div>
        );
    }

}

export default withRouter(EstoqueCentro);

